import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1);
import { onMounted } from 'vue';
import 'swiper/swiper-bundle.css';
import { useRoute, useRouter } from 'vue-router';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useLess } from '@/models/hooks';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { jumpInteractionType, imageCutEdgeAndSetSize } from '@/utils/common';
export default {
  __name: 'RotationPoster',
  props: {
    properties: {
      // Component configuration information, received from parent component
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  setup(__props) {
    useLess('views/landingPage/rotationPoster/RotationPoster.less');
    const route = useRoute();
    const router = useRouter();
    SwiperCore.use([Pagination, Navigation, Autoplay]);
    onMounted(() => {
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.rotationPosterWidget,
        ...recordParams
      });
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      const _directive_reload_img = _resolveDirective("reload-img");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["rotation-poster", {
          'rotation-poster-card': __props.properties.presentationType === 'THREE_IMENSIONAL'
        }]),
        style: _normalizeStyle([{
          paddingBottom: `${__props.properties.bottomSpacing}px`
        }])
      }, [_createVNode(_unref(Swiper), {
        pagination: true,
        loop: __props.properties.circulateType === 'LOOP',
        autoplay: __props.properties.slideType === 'AUTOMATIC' ? {
          delay: Number(__props.properties.swipeTime * 1000),
          disableOnInteraction: false
        } : false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.interactionTypeInfo, item => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: item.id
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("img", {
              class: "slide-img",
              onClick: $event => _unref(jumpInteractionType)(item, _unref(router))
            }, null, 8, _hoisted_1), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.picUrl)], [_directive_reload_img, _unref(imageCutEdgeAndSetSize)(item.picUrl)]])]),
            _: 2
          }, 1024);
        }), 128)), _hoisted_2]),
        _: 1
      }, 8, ["loop", "autoplay"])], 6);
    };
  }
};